<template>
        <span>
                <el-button type="primary"
                        icon="el-icon-plus"
                        size="small"
                        @click="openDialog"
                >新增</el-button>
                <el-dialog
                        :title="title"
                        width="65%"
                        top="60px"
                        :bottom="0"
                        append-to-body
                         style="max-hight:100vh;margin-bottom:0"
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        :before-close="handleClose"
                        v-loading="loading"
                        class="planManagement-addForm"

                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow: scroll;">
                <avue-form ref="form" v-if="dialogVisible" v-model="form" :option="option" @reset-change="emptytChange" @submit="addPlan">
                        <!-- 任务日期 -->
                        <template slot="executeDate">
                                <el-date-picker
                                        v-model="form.executeDate"
                                        type="daterange"
                                        :picker-options="pickerOptions"
                                        range-separator="至"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                                </el-date-picker>

                        </template>
                        <template slot="timeQuantum">
                                <select-time
                                        :value.sync="form.timeQuantum"
                                        ref="selectTimeAdd"
                                >
                                </select-time>
                        </template>
                        <template slot="orderModuleType">
                                <el-cascader
                                v-model="form.orderModuleType"
                                :disabled="orderModuleTypeDisabled"
                                :options="cascaderOptions"
                                placeholder="请选择关联工单类型"
                                :props="{ checkStrictly: true }"
                                ></el-cascader>
                        </template>
                        <template slot="cycleRule">
                                <div style="display:flex;">
                                        <span style="margin-right:10px;">自</span>
                                        <div style="width:180px">
                                                <el-date-picker
                                                        v-model="cycleTypeForm.firstDate"
                                                        type="date"

                                                        :picker-options="pickerOptions"

                                                        placeholder="请选择 任务日期">
                                                </el-date-picker>
                                        </div>
                                        <span style="margin:0 10px;">
                                                开始，巡检
                                        </span>
                                        <el-input  v-model="cycleTypeForm.days" @input="daysInput" style="width:120px">

                                        </el-input>
                                        <span style="margin:0 10px;">
                                                天，暂停
                                        </span>
                                        <el-input  v-model="cycleTypeForm.pauseDays" @input="pauseDaysInput" style="width:120px">

                                        </el-input>
                                        <span style="margin:0 10px;">
                                                天
                                        </span>
                                </div>

                        </template>
                        <template slot="executeUserId">
                                <div style="display:flex;" v-if="form.orderRelateFlag==0">
                                        <span style="margin-right:10px;">共有</span>
                                        <choice-people  :allUserList='realInspectManList' placeholder="请选择 计划人员" :remainUserListInside.sync="realInspectManList" :projectId="form.projectId"  message="请选择计划人员"  />
                                        <!-- <choicePeople  :allUserList='realInspectManList' :remainUserListInside.sync="realInspectManList" :projectId="form.projectId"  message="请选择计划人员"  ></choicePeople> -->
                                        <span style="margin-left:10px;">参与计划</span>
                                </div>
                                <div style="display:flex;" v-else>
                                        <span style="margin-right:10px;">共有</span>
                                        <selectGroupUser placeholder="请选择 计划人员" :value.sync="form.executeUserId" ref="selectGroupUser" :projectId.sync="form.projectId" :moduleType.sync='form.orderModuleType[0]' :subModuleId.sync="form.orderModuleType[1]"></selectGroupUser>
                                        <span style="margin-left:10px;">参与计划</span>
                                </div>

                        </template>
                        <template slot="allotType">

                                <div>
                                        <span>
                                                按
                                        </span>
                                        <el-select style="width:130px !important;margin:0 10px;" v-model="form.allotType">
                                                <el-option
                                                        v-for="item in  allotTypeList"
                                                        :key="item.id"
                                                        :label="item.dictValue"
                                                        :value="item.dictKey">

                                                </el-option>
                                        </el-select>
                                        <span>
                                                方式进行任务分配
                                        </span>
                                </div>

                        </template>
                        <template slot="taskContent">
                                <div>
                                        <el-row>
                                                <selectArea v-if="dialogVisible && form.type == 3"  :taskContentData.sync="taskContentData"  :projectId.sync='form.projectId'></selectArea>
                                               <relateDevice @getDeviceInfo="getDeviceInfo" v-if="dialogVisible && form.type != 3" :taskContentData.sync="taskContentData"  :taskType.sync="form.type" :standardId='standardId' :projectId.sync='form.projectId'></relateDevice>
                                               <el-button size="small" type="primary" @click="removeSelect">移除</el-button>
                                               <el-button size="small" type="primary" @click="moveUpSelect">上移</el-button>
                                               <el-button size="small" type="primary" @click="moveDownSelect">下移</el-button>
                                        </el-row>
                                        <el-row style="margin-top:20px;">
                                               <avue-crud
                                                :data="taskContentData"
                                                :option="crudOption"
                                                ref="crud"
                                                :table-loading="loading"
                                                @selection-change="selectionChange"

                                               >
                                                <template slot="standardName" slot-scope="scope">
                                                       <div v-if="form.type==1">
                                                                <div v-if="!scope.row.showEdit">
                                                                        <div>{{scope.row.standardName}}</div>
                                                                        <el-button v-if="scope.row.standardName" size="mini" type="primary" plain @click="changeStandard(scope.row)">切换标准</el-button>
                                                                </div>
                                                                <div v-else>
                                                                        <el-select  v-model="scope.row.standardId" placeholder="请选择" @change="(val)=>{
                                                                                standardChange(scope.row)}">
                                                                                <el-option
                                                                                        v-for="item in scope.row.deviceInspectStandard"
                                                                                        :key="item.id"
                                                                                        :label="item.name"
                                                                                        :value="item.id">
                                                                                </el-option>
                                                                        </el-select>

                                                                </div>
                                                        </div>
                                                        <div v-else><span>{{scope.row.standardName}}</span></div>
                                                </template>
                                                </avue-crud>
                                        </el-row>
                                </div>
                        </template>
                        <template slot="createTaskAheadDays">
                                <div style="display:flex;">
                                        <span>提前</span>
                                        <el-input placeholder="请输入 天数" style="width:120px;margin:0 15px;" type="number"  @input="createTaskAheadDaysInput"  v-model="form.createTaskAheadDays"></el-input>
                                        <span>天生成任务</span>
                                </div>
                        </template>
                        <template slot="taskNotifyAheadNum">
                                <div>

                                        <el-input  @input="taskNotifyAheadNumInput" placeholder="请输入 任务通知时限" v-model="form.taskNotifyAheadNum">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskNotifyAheadUnit">
                                                                <option
                                                                        v-for="item in  taskNotifyAheadUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskFinishPicMustFlag" true-label="1" false-label="0" >巡检时强制提交照片，数量1~4张</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskExecuteForceSequenceFlag" true-label="1" false-label="0">强制按巡检内容书顺序巡检</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <template slot="taskOverdueTimeNum">
                                <div>
                                        <el-input  @input="taskOverdueTimeNumInput" placeholder="请输入 任务过期时限" v-model="form.taskOverdueTimeNum">
                                                <template slot="append">
                                                        <select style="width:80px;" v-model="form.taskOverdueTimeUnit">
                                                                <option
                                                                        v-for="item in  taskOverdueTimeUnitList"
                                                                        :key="item.id"
                                                                        :label="item.dictValue"
                                                                        :value="item.dictKey">

                                                                </option>
                                                        </select>
                                                </template>
                                        </el-input>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueCloseFlag" true-label="1" false-label="0">逾期任务自动关闭</el-checkbox>
                                        </el-row>
                                        <el-row>

                                               <el-checkbox v-model="form.taskOverdueSubmitForbidFlag" true-label="1" false-label="0">任务过期不允许执行</el-checkbox>
                                        </el-row>
                                </div>

                        </template>
                        <!-- <template slot-scope="scope" slot="menuForm">
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </template> -->

                </avue-form>
                </div>
                <template slot="footer">
                        <div style="text-align:right;">
                                <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="$refs.form.submit();">保 存</el-button>
                                <el-button icon="el-icon-circle-close" size="small" @click="handleClose(false)">取 消</el-button>
                        </div>
                </template>
                </el-dialog>
        </span>
</template>
<script>

import {
        addPlan,
        getDictionary,
        getOrderType,
        getPlanDetail,
        updatePlan,
        getBisDictData,
        getStandardName
} from "@/api/crmedical/device/planManagement";
import {
        standardDetailByDeviceId
} from "@/api/crmedical/device/taskManagement";
import selectTime from "../components/select-time-box.vue";
import selectGroupUser from "../components/user-select-box.vue";
import choicePeople from '@/components/user-edit-box/user-edit-box2';
import {areaOption,deviceOption,omitNumber,weeksDict,monthDict} from "./option.js";
import relateDevice from '../components/choice-device';
import selectArea from "../components/choice-area.vue";
export default {
        components:{selectTime,choicePeople,selectGroupUser,relateDevice,selectArea},
        props:{
                projectId:{
                        type:String,
                        default:'',
                }
        },
        data(){
                return{

                        cycleTypeForm:{
                                firstDate:'',
                                days:"",
                                pauseDays:'',
                        },//分配方式自定义
                        title:"",
                        allotTypeList:[],
                        orderModuleTypeDisabled:false,
                        cascaderOptions:[],
                        taskContentData:[],
                        taskContentDataIds:[],
                        loading:false,
                        data:[{test:'test'}],
                        taskNotifyAheadUnitList:[
                                {
                                        dictKey:1,
                                        dictValue:'小时'
                                }
                        ],
                        taskOverdueTimeUnitList:[],
                        isEdit:false,
                        realInspectManList:[],
                        selectedTime:[],
                        quantumTime:[],
                        dialogVisible:false,
                        dialogFull:false,
                        selectTimeFlag:false,
                        selectionData:[],
                        form:{
                                projectId:'',
                                executeUserId:[],
                        },
                        crudOption:deviceOption,
                        // 可选择日期
                        pickerOptions:{
                                disabledDate(time) {
                                        return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
                                }
                        },
                        option:{

                                size:'small',
                                menuPosition:'right',
                                emptyBtn:false,
                                submitIcon:'el-icon-circle-plus-outline',
                                submitText: '保 存',
                                submitBtn:false,
                                labelWidth:120,
                                column:[
                                        {
                                                label: "项目名称",
                                                prop: "projectId",
                                                type:'select',
                                                span:8,
                                                cascaderItem:['orderModuleType'],
                                                dicUrl:'/api/v4ward/project/getProjectList',
                                                props:{
                                                        label:"name",
                                                        value:'id'
                                                },
                                                rules: [{
                                                        required: true,
                                                        message: "请选择项目",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "任务类型",
                                                prop: "type",
                                                span:8,
                                                cascaderItem:['orderModuleType'],
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                dicUrl:'/api/blade-system/dict/dictionary?code=task_type',
                                                type:"select",
                                                rules: [{
                                                        required: true,
                                                        message: "请选择任务类型",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "任务子类型",
                                                prop: "subTypeId",
                                                dicData:[],
                                                props:{
                                                        label:'dictValue',
                                                        value:'dictKey',
                                                },
                                                type:"select",
                                                 
                                                span:8,

                                        },
                                        {
                                                label: "计划名称",
                                                prop: "name",
                                                type:"input",
                                                span:24,
                                                maxlength:20,
                                                showWordLimit:true,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入计划名称",
                                                        trigger: "change"
                                                }]

                                        },
                                        {
                                                label: "计划日期",
                                                prop: "executeDate",
                                                type: 'date',
                                                span:8,
                                                formslot:true,
                                                pickerOptions: {
                                                        disabledDate(time) {
                                                                return time.getTime() < Date.now() - 8.64e7;  //如果没有后面的-8.64e7就是不可以选择今天的
                                                        }
                                                },
                                                format: 'yyyy-MM-dd',
                                                valueFormat: 'yyyy-MM-dd',
                                                rules: [{
                                                        required: true,
                                                        message: "请选择计划日期",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                type: 'radio',
                                                label: '关联工单',
                                                value:1,
                                                dicData: [
                                                        {
                                                                label: '是',
                                                                value: 1
                                                        },
                                                        {
                                                                label: '否',
                                                                value: 0
                                                        },
                                                ],
                                                span: 8,
                                                display: true,
                                                props: {
                                                        label: 'label',
                                                        value: 'value'
                                                },
                                                prop: 'orderRelateFlag'
                                        },
                                        {
                                                label: "关联工单类型",
                                                prop: "orderModuleType",
                                                type:"tree",
                                                formslot:true,
                                                span:8,

                                        },
                                        {
                                                label: "计划周期",
                                                prop: "cycleType",
                                                type:"radio",
                                                value:'1',
                                                display:true,
                                                props: {
                                                        label: 'dictValue',
                                                        value: 'dictKey'
                                                },
                                                dicUrl:"/api/blade-system/dict/dictionary?code=plan_cycle_type",
                                                span:24,
                                        },
                                        {
                                                label: "具体时间",
                                                prop:"cycleRule",
                                                type:"checkbox",

                                                value:[],
                                                rules: [{
                                                        required: true,
                                                        message: "具体时间不能为空",
                                                        trigger: "change"
                                                }],
                                                dicData: weeksDict,
                                                span:24,
                                        },
                                        {
                                                label: "时间段",
                                                formslot:true,
                                                prop: "timeQuantum",
                                                span:24,
                                                rules: [{
                                                        required: true,
                                                        message: "请输入具体时间段，格式为hh:mm~hh:mm+d,hh:mm~hh:mm+d，其中hh:mm为小时分钟，d代表跨天天数",
                                                        trigger: "change"
                                                }]
                                        },
                                        {
                                                label: "计划人员",
                                                formslot:true,
                                                prop: "executeUserId",
                                                // rules: [{
                                                //         required: true,
                                                //         message: "请选择任务人员",
                                                //         trigger: "change"
                                                // }],
                                                span:24,

                                        },
                                        {
                                                label: "",
                                                formslot:true,
                                                prop: "allotType",
                                                span:24,

                                        },
                                        {
                                                label: "标准名称",
                                                prop: "standardId",
                                                dicData:[],
                                                props:{
                                                        label:'standardName',
                                                        value:'standardId',
                                                },
                                                type:"select",
                                                span:12,
                                                rules: [{
                                                        required: true,
                                                        message: "请选择巡检标准",
                                                        trigger: "change"
                                                }],
                                                display:false
                                        },
                                        {
                                                label: "计划内容",
                                                formslot:true,
                                                prop: "taskContent",
                                                span:24,
                                                rules: [{
                                                        required: true,
                                                        message: "请添加计划内容",
                                                        trigger: "change"
                                                }],

                                        },
                                        {
                                                title: '分割线',
                                                component: 'el-divider',
                                                span: 24 ,
                                                labelWidth: '0px',
                                                params: {
                                                        html: '<h3 style="color:#333">执行任务要求</h3>',
                                                        contentPosition: 'left'
                                                },
                                                prop: '1632968429167_6112'
                                        },
                                        {
                                                label: "",
                                                formslot:true,
                                                prop: "createTaskAheadDays",
                                                span:24,

                                        },
                                        {
                                                label: "任务通知时限",
                                                formslot:true,
                                                prop: "taskNotifyAheadNum",
                                                span:12,

                                        },
                                        {
                                                label: "任务过期时限",
                                                formslot:true,
                                                prop: "taskOverdueTimeNum",
                                                span:12,

                                        },

                                ]
                        },
                        selectIds:"",
                        id:'',
                        isApi:false
                }
        },
        watch:{
                'form.subTypeId'(){
                        let subTypeIdColumn = this.findObject(this.option.column,"standardId");
                        
                                this.form.standardId =''
                        
                        if(this.form.subTypeId==''||this.form.subTypeId==undefined){
                                 subTypeIdColumn.display =false
                        }else{
                                console.log("ducu",this.form.subTypeId)
                                subTypeIdColumn.display =true
                                this.getStandardBysubTypeId(this.form.subTypeId,this.form.projectId).then(res=>{
                                        subTypeIdColumn.dicData = res
                                })
                                
                        }
                },
                'projectId'(){
                        this.form.projectId = this.projectId;
                },
                "form.projectId"(){
                        this.realInspectManList = [];
                        this.getOrderType();
                        if(this.form.orderRelateFlag==1){
                                this.$refs.selectGroupUser.reset();
                        }

                },
                "form.cycleType"(val){

                        this.form.cycleRule = "";

                        let cycleRule = this.findObject(this.option.column,"cycleRule");
                        console.log(1111111111111111111,val)
                        if(val==1){
                                console.log(cycleRule)
                                cycleRule.display = false;
                                cycleRule.formslot = false;
                                this.cycleTypeForm = {
                                        firstDate:'',
                                        days:"",
                                        pauseDays:'',
                                }
                        }else if(val==2){
                                cycleRule.display = true;
                                cycleRule.formslot = false;
                                cycleRule.dicData = weeksDict;
                                cycleRule.label = "具体时间";
                                cycleRule.rules = [{
                                                        required: true,
                                                        message: "具体时间不能为空",
                                                        trigger: "change"
                                                }];
                                this.cycleTypeForm = {
                                        firstDate:'',
                                        days:"",
                                        pauseDays:'',
                                }
                        }else if(val==3){
                                cycleRule.display = true;
                                cycleRule.formslot = false;
                                cycleRule.dicData = monthDict;
                                cycleRule.label = "具体时间";
                                cycleRule.rules = [{
                                                        required: true,
                                                        message: "具体时间不能为空",
                                                        trigger: "change"
                                                }];
                                this.cycleTypeForm = {
                                        firstDate:'',
                                        days:"",
                                        pauseDays:'',
                                }

                        }else if(val==99){
                                cycleRule.display = true;
                                cycleRule.formslot = true;
                                cycleRule.dicData = [];
                                cycleRule.label = "初次巡检";
                                cycleRule.rules = [{
                                                        required: true,
                                                        message: "请填写完整得初次巡检",
                                                        trigger: "change"
                                                }];
                        }

                },
               async "form.type"(val){
                        this.form.subTypeId = ''
                        console.log("orm.type")
                        let column = JSON.parse(JSON.stringify(this.option.column));

                        let subTypeIdColumn = this.findObject(this.option.column,"subTypeId");

                        if(val==1){
                                this.crudOption = deviceOption ;
                                subTypeIdColumn.rules = [];
                                subTypeIdColumn.disabled = true;
                        }else if(val==2){
                                console.log('222',subTypeIdColumn)
                                this.crudOption = deviceOption;
                                subTypeIdColumn.rules = [];
                                subTypeIdColumn.disabled = true;

                        }else if(val==3){
                                 console.log('ddd****')
                                this.crudOption = areaOption;
                                subTypeIdColumn.disabled = false;

                                subTypeIdColumn.rules =[{required: true, message: "请选择任务子类型",trigger: "change"}]
                               await getBisDictData({
                                        projectId:this.form.projectId,
                                        code:'project_general_inspect_type'
                                }).then(res=>{
                                         console.log('dce1111ee****', res.data)
                                        subTypeIdColumn.dicData = res.data
                                })
                                 
                                 
                        }else{
                                 console.log('333',subTypeIdColumn)
                                this.crudOption = areaOption;
                                subTypeIdColumn.disabled = false;
                                 subTypeIdColumn.dicData =[]
                                subTypeIdColumn.rules =[{required: true, message: "请选择任务子类型",trigger: "change"}]
                               
                        }

                        this.taskContentData = [];
                        this.taskContentDataIds = [];
                        column[2] = subTypeIdColumn
                        this.option.column = column;
                        this.getOrderType();




                },
                "form.orderRelateFlag"(val){

                        if(this.form.orderRelateFlag==1){
                                setTimeout(()=>{
                                        this.$refs.selectGroupUser.reset();
                                })

                        }else{
                                this.realInspectManList = [];
                                this.form.orderModuleType = [];
                        }
                        let column = JSON.parse(JSON.stringify(this.option.column));

                        let executeUserIdColumn = this.findObject(this.option.column,"executeUserId");
                        let orderModuleTypeColumn = this.findObject(this.option.column,"orderModuleType");
                        if(val==1){
                                executeUserIdColumn.rules = [];
                                this.orderModuleTypeDisabled = false;
                                orderModuleTypeColumn.disabled = false;
                                orderModuleTypeColumn.rules = [{required: true,message: "请选择关联工单类型",trigger: "change"}]

                        }else{

                                this.form.orderModuleType = "";
                                this.orderModuleTypeDisabled = true;
                                orderModuleTypeColumn.disabled = true;
                                orderModuleTypeColumn.rules = [];
                                executeUserIdColumn.rules =[{required: true, message: "请选择计划人员",trigger: "change"}]
                        }
                        column[6] = orderModuleTypeColumn;
                        column[10] = executeUserIdColumn;
                        this.option.column = column;
                },
                "realInspectManList"(val){
                        if(val.length>0){
                                this.form.executeUserId = val;

                        }else{
                                this.form.executeUserId = [];
                        }
                },
                "cycleTypeForm.firstDate"(val){


                        if(this.cycleTypeForm.firstDate && this.cycleTypeForm.days!='' && this.cycleTypeForm.pauseDays != ''){
                                this.form.cycleRule = val;

                        }else{
                                this.form.cycleRule = [];
                        }
                },
                "cycleTypeForm.days"(val){


                        if(this.cycleTypeForm.firstDate && this.cycleTypeForm.days!='' && this.cycleTypeForm.pauseDays != ''){
                                this.form.cycleRule = val;

                        }else{
                                this.form.cycleRule = '';
                        }
                },
                "cycleTypeForm.pauseDays"(val){


                        if(this.cycleTypeForm.firstDate && this.cycleTypeForm.days!='' && this.cycleTypeForm.pauseDays != ''){
                                this.form.cycleRule = val;

                        }else{
                                this.form.cycleRule = '';
                        }
                },
                "taskContentData"(val){
                        if(val.length>0){
                                this.form.taskContent = true;
                        }else{
                                this.form.taskContent = "";
                        }
                }

        },
        created(){

        },
        methods:{
                //根据工单子类型获取标准
              async  getStandardBysubTypeId(inspectType,projectId){
                      console.log("89898")
                        let data =[]
                     await   getStandardName({
                                projectId,
                                inspectType
                        }).then(res=>{
                                  data = res.data 
                        })
                        return data
                },
                 standardChange(row){
                        row.deviceInspectStandard.forEach(element => {
                                if(element.id == row.standardId){
                                        row.standardName =element.name
                                }
                        });
                        row.showEdit = false
                 },
                changeEnd(row){
                        row.showEdit = false
                },
                changeStandard(row){
                        console.log('kkk',row)
                        if(!row.deviceInspectStandard){
                                standardDetailByDeviceId({deviceId:row.id}).then(res=>{
                                this.$set(row,'deviceInspectStandard',res.data)
                                this.$set(row,'showEdit',true)
                        })
                        }
                        this.$set(row,'showEdit',true)
                        // row.isEdit = true
                },
                getDeviceInfo(data){
                        console.log("dddxzxcxzc")
                        if(this.form.type =='1'){
                                 data.forEach(ele=>{
                                         this.$set(ele,'showEdit',false)
                                // if(ele.deviceInspectStandard.length>0){
                                //         if(ele.standardId==''){
                                //                 ele.standardId = ele.deviceInspectStandard[0].id
                                //         }

                                // }

                        })
                        this.taskContentData =[...data]
                        console.log(this.taskContentData)
                        }

                },
                // 获取关联工单类型
                getOrderType(){
                        if(this.form.orderRelateFlag===0){
                                return;
                        }
                        this.cascaderOptions = [];
                        console.log(this.form.orderModuleType)
                        this.form.orderModuleType = "";
                        if(this.form.type && this.form.projectId){
                                getOrderType({taskType:this.form.type,projectId:this.form.projectId}).then(res=>{
                                        let temArr = [];
                                        let temObj = {};
                                        temObj.label = res.data.orderModuleTypeName;
                                        temObj.value = res.data.orderModuleType;
                                        temObj.children = [];
                                        if(res.data.subModuleList){
                                                res.data.subModuleList.forEach(ele=>{
                                                        let a = {
                                                                label:ele.name,
                                                                value:ele.id
                                                        };
                                                        temObj.children.push(a);

                                                })
                                        }

                                        temArr.push(temObj);
                                        this.cascaderOptions = temArr;
                                }).catch(err=>{
                                        this.cascaderOptions = [];
                                })
                        }

                },
                // 控制输入框输入数字
                taskNotifyAheadNumInput(e){
                        this.form.taskNotifyAheadNum = omitNumber(e)
                },
                // 控制输入框输入数字
                taskOverdueTimeNumInput(e){
                        this.form.taskOverdueTimeNum = omitNumber(e)
                },
                // 控制提前多少天输入 只能输入整数
                createTaskAheadDaysInput(e){
                        let value = String(e).slice(0,8);
                        this.form.createTaskAheadDays = parseInt(value);
                },
                // 控制自定义计划周期天输入
                pauseDaysInput(e){
                        let value = String(e).slice(0,8);
                        this.cycleTypeForm.pauseDays = parseInt(value);
                },
                daysInput(e){
                        let value = String(e).slice(0,8);
                        this.cycleTypeForm.days = parseInt(value);
                },
                // 数据准备
                async initData(add){
                        // 任务提前通知时限单位
                        await getDictionary("task_notify_ahead_unit").then(res=>{
                                this.taskNotifyAheadUnitList = res.data;
                                if(add){
                                        this.form.taskNotifyAheadUnit = res.data[0]?res.data[0].dictKey:'';
                                }

                        })
                        // 任务过期通知时限单位
                        await getDictionary("task_overdue_time_unit").then(res=>{
                                this.taskOverdueTimeUnitList = res.data;
                                if(add){
                                        this.form.taskOverdueTimeUnit = res.data[0]?res.data[0].dictKey:'';

                                }
                        })
                        // 分配方式
                        await getDictionary("task_allot_type").then(res=>{
                                this.allotTypeList = res.data;
                                if(add){
                                        this.form.allotType = res.data[0]?res.data[0].dictKey:'';

                                }
                        })
                        if(add){
                                this.form.executeUserId = [];
                                return;
                        }
                        // 获取详情
                        this.isApi = true
                        await getPlanDetail({id:this.form.id}).then(res=>{
                                let data = res.data;
                                this.taskContentData = res.data.targetList;
                                if(res.data.type ==3){
                                        this.taskContentData.forEach(item=>{
                                        item.name = item.areaName
                                        item.$deptId = item.deptName
                                        
                                })
                                }
                                this.form.name = res.data.name;
                                this.form.orderRelateFlag = res.data.orderRelateFlag;
                                this.form.subTypeId = res.data.subTypeId
                            
                                if(data.orderSubModuleId){
                                        this.form.orderModuleType = [Number(data.orderModuleType) ,String(data.orderSubModuleId)];
                                }else{
                                        this.form.orderModuleType = [Number(data.orderModuleType)];
                                }

                                this.form.cycleRule = data.cycleRule.split(",");
                                this.form.timeQuantum = data.timeQuantum;
                                this.form.taskNotifyAheadUnit=data.taskNotifyAheadUnit;
                                this.form.taskOverdueTimeUnit=data.taskOverdueTimeUnit;
                                 
                                setTimeout(()=>{
                                            this.form.standardId = res.data.standardId
                                        this.$set(this.form,'allotType',data.allotType);
                                        this.$set(this.form,'taskExecuteForceSequenceFlag',data.taskExecuteForceSequenceFlag);
                                        this.$set(this.form,'taskFinishPicMustFlag',data.taskFinishPicMustFlag);
                                        this.$set(this.form,'taskOverdueCloseFlag',data.taskOverdueCloseFlag);
                                        this.$set(this.form,'taskOverdueSubmitForbidFlag',data.taskOverdueSubmitForbidFlag);
                                        this.$set(this.form,'timeQuantum',data.timeQuantum);

                                })

                                // this.form.taskExecuteForceSequenceFlag = String(data.taskExecuteForceSequenceFlag);
                                // this.form.taskFinishPicMustFlag = String(data.taskFinishPicMustFlag);
                                // this.form.taskOverdueCloseFlag = String(data.taskOverdueCloseFlag);
                                // this.form.taskOverdueSubmitForbidFlag = String(data.taskOverdueSubmitForbidFlag);

                                console.log(23323232323)
                                this.form.taskNotifyAheadNum = data.taskNotifyAheadNum;
                                this.form.taskOverdueTimeNum = data.taskOverdueTimeNum;

                                this.form.orderRelateFlag = data.orderRelateFlag

                                this.form.createTaskAheadDays = data.createTaskAheadDays;
                                // this.form.orderModuleType = [data.orderModuleType,data.orderSubModuleId]
                                console.log(23323232323)
                                // 计划人员
                               if(this.form.orderRelateFlag==1){
                                        let userList = [];
                                        data.userList.forEach(ele=>{
                                                userList.push(ele.id)
                                        })
                                        this.$refs.selectGroupUser.getGroupListForOrder(userList,data.orderModuleType,data.orderSubModuleId);
                               }else{
                                        let userList = [];
                                        data.userList.forEach(ele=>{
                                                userList.push({
                                                        id:ele.id,
                                                        realNameAndPhone:ele.phone?ele.realName + " ("+ ele.phone+")":ele.realName,
                                                        realName:ele.realName
                                                })
                                        })
                                        setTimeout(()=>{
                                                this.realInspectManList = userList;
                                        })

                               }
                               console.log(data.cycleType)
                                
                               // 计划得任务分配方式
                               this.$set(this.form,"cycleType",String(data.cycleType));
                                if(this.form.cycleType == 99){
                                        console.log(data)
                                        let cycleRule = JSON.parse(data.cycleRule);
                                        this.cycleTypeForm.firstDate = this.dayjs(cycleRule.firstDate);
                                        this.cycleTypeForm.days = cycleRule.days;
                                        this.cycleTypeForm.pauseDays = cycleRule.pauseDays;
                                        console.log(cycleRule)

                                }else if(this.form.cycleType == 3){
                                        let cycleRule = JSON.parse(data.cycleRule);
                                        setTimeout(()=>{
                                                this.form.cycleRule = cycleRule.data?cycleRule.data.split(","):[];
                                        })

                                }else if(this.form.cycleType == 2){

                                        let cycleRule = JSON.parse(data.cycleRule);
                                        setTimeout(()=>{
                                                this.form.cycleRule = cycleRule.data?cycleRule.data.split(","):[];
                                        })

                                }else{
                                        this.form.cycleRule = "";

                                }

                                this.loading = false;
                                this.isApi = false 
                        }).catch(()=>{
                                this.loading = false;
                        })

                },
                // 移除
                removeSelect(){
                        let temArr = [];
                        this.taskContentData.forEach((ele,index)=>{
                                if(this.selectIds.indexOf(ele.id)<0){
                                        temArr.push(ele)
                                }
                        })
                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)
                },
                // 排序方法
                compare(property) {
                        return function (a, b) {
                                var value1 = a[property];
                                var value2 = b[property];
                                return value1 - value2;
                        }
                },
                // 上移
                moveUpSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[0].id)>-1){
                                this.$message({
                                        message: '已经到顶了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }
                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));

                        // this.selectionData.reverse();
                        // 给已选择得数据排序
                        this.selectionData.sort(this.compare("$index"));

                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })
                        this.selectionData.forEach((ele,index)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                console.log(i)
                                if(i>-1){

                                        [this.taskContentDataIds[i-1],this.taskContentDataIds[i]] = [this.taskContentDataIds[i],this.taskContentDataIds[i-1]];
                                        [temArr[i-1],temArr[i]] = [temArr[i],temArr[i-1]]
                                }
                        })


                        setTimeout(()=>{
                                console.log(temArr);
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)


                        this.loading = false;
                },
                // 下移
                moveDownSelect(){
                        if(!this.selectionData.length){
                                this.$message({
                                        message: '请选择数据',
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.selectIds.indexOf(this.taskContentData[this.taskContentData.length-1].id)>-1){
                                this.$message({
                                        message: '已经到底了，无法再移动！',
                                        type: 'warning'
                                });
                                return;
                        }

                        this.loading = true;
                        let temArr = JSON.parse(JSON.stringify(this.taskContentData));
                        this.selectionData.reverse();

                        this.taskContentDataIds = []
                        this.taskContentData.forEach(ele=>{
                               this.taskContentDataIds.push(ele.id);
                        })

                        this.selectionData.forEach((ele,index)=>{

                                let i = this.taskContentDataIds.indexOf(ele.id);
                                console.log(i)
                                if(i>-1){

                                        [this.taskContentDataIds[i],this.taskContentDataIds[i+1]] = [this.taskContentDataIds[i+1],this.taskContentDataIds[i]];
                                        [temArr[i],temArr[i+1]] = [temArr[i+1],temArr[i]]
                                }
                        })



                        setTimeout(()=>{
                                this.taskContentData = temArr;
                                this.loading = false;
                        },0)



                },
                // 任务内容 选择的数据
                selectionChange(val) {

                        this.selectionData = val;
                        console.log(this.selectionData)
                        let Ids = [];

                        val.forEach((element) => {
                                Ids.push(element.id);
                        });
                        this.selectIds = Ids.join(',');
                },
                // 弹窗关闭前
                handleClose(done){
                        let self = this;
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                if(done){
                                        done();
                                        this.selectTimeFlag = false;

                                }else{
                                        this.selectTimeFlag = false;
                                        self.dialogVisible = false;
                                }
                        })
                        .catch(()=> {

                        });
                },
                // 打开弹窗
                openDialog(row,type){
                        console.log(1)
                        this.selectedTime=[];
                        this.quantumTime = [];
                        this.form = {};
                        console.log(2)
                        this.dialogVisible = true;
                        this.selectTimeFlag = true;

                        if(type){
                                this.loading = true;
                                if(type=='copy'){
                                        this.title = "复制"
                                }else if(type == 'edit'){
                                        this.title = "编辑"

                                }else{
                                        this.title = '新增'
                                }
                                this.form.id = row.id;

                                this.form.type = String(row.type);
                                this.form.cycleType = String(row.type);
                                this.form.executeDate = [new Date(row.validStartDate),new Date(row.validEndDate)]

                                this.form.projectId = row.projectId;
                                this.initData(false);
                        }else{
                                this.title = '新增'

                                setTimeout(()=>{
                                        console.log(this.projectId)
                                        this.form.projectId = this.projectId;

                                })
                                this.form.orderRelateFlag = 1;
                                this.form.cycleType = "1";
                                this.form.type = '';
                                this.taskContentData = [];
                                this.initData(true);

                        }




                },

                // 新增计划
                addPlan(form,done){
                        console.log(form)
                        console.log("this.taskContentData",this.taskContentData)
                        form.validStartDate = this.dayjs(form.executeDate[0]).format("YYYY-MM-DD 00:00:00");
                        form.validEndDate = this.dayjs(form.executeDate[1]).format("YYYY-MM-DD 23:59:59");
                        form.targetList = [];
                        this.taskContentData.forEach(ele=>{

                                let obj = {
                                        targetId:ele.id,
                                        standardId:ele.standardId
                                }
                                form.targetList.push(obj)
                        })
                        // 计划得任务分配方式
                        console.log(form.cycleRule)
                        console.log(this.cycleTypeForm)
                        if(form.cycleType==99){
                                this.cycleTypeForm.firstDate = this.dayjs(this.cycleTypeForm.firstDate).format("YYYY-MM-DD 00:00:00");
                                form.cycleRule = JSON.stringify(this.cycleTypeForm);
                        }else if(form.cycleType==3){
                                let cycleRule = form.cycleRule.join(",");
                                form.cycleRule = JSON.stringify({data:cycleRule});

                        }else if(form.cycleType==2){
                                let cycleRule = form.cycleRule.join(",");
                                form.cycleRule = JSON.stringify({data:cycleRule});
                        }else{
                                form.cycleRule = JSON.stringify({});
                        }
                        // 处理计划人员
                        form.userList = [];
                        if(form.orderRelateFlag==1){
                                form.userList = form.executeUserId
                        }else{
                                this.realInspectManList.forEach(ele=>{
                                        form.userList.push(ele.id);
                                })
                        }
                        if(form.orderModuleType.length!=0){
                                form.orderSubModuleId = form.orderModuleType[1];
                                form.orderModuleType = form.orderModuleType[0];
                        }
                        this.form.createTaskAheadDays = parseInt(this.form.createTaskAheadDays);
                        if(this.title == "编辑"){
                                updatePlan(form).then(res=>{
                                        this.dialogVisible = false;
                                        this.selectTimeFlag = false;
                                        this.$message({
                                                message: '修改成功！',
                                                type: 'success'
                                        });
                                        this.$emit('onload')
                                        done();
                                })
                        }else{
                                form.id = null;
                                console.log('****',form)
                                addPlan(form).then(res=>{
                                        this.dialogVisible = false;
                                        this.selectTimeFlag = false;
                                        if(this.title == "复制"){
                                                this.$message({
                                                        message: '复制成功！',
                                                        type: 'success'
                                                });
                                        }else{
                                                this.$message({
                                                        message: '新增成功！',
                                                        type: 'success'
                                                });
                                        }

                                        this.$emit('onload')
                                        done();
                                })
                        }

                        done();

                },
                // 获得时间选择器传来的值
                getTime(time) {
                        // this.inspectplanAddForm.timeQuantum = time;
                        console.log(time);
                        if(time){
                                let timeList = [];
                                time.forEach((ele,index)=>{
                                        timeList.push(ele.time);
                                        })
                                this.form.timeQuantum = timeList.join(',');
                        }
                },
        }
}
</script>

<style lang="scss" >
.planManagement-addForm{
        .avue-dialog__footer{
                display: flex;
                justify-content:flex-end;
        }
        .el-form-item__error{
                position: relative;
        }
}

</style>